import React from 'react';

function clampValue(value) {
  if (value == null || Number.isNaN(Number(value))) return null;
  return Math.max(0, Math.min(1, Number(value)));
}

export default function SmartiLabScoreBar({ label, value, helper, variant = 'primary' }) {
  const normalized = clampValue(value);
  const percentage = normalized == null ? '0%' : `${Math.round(normalized * 100)}%`;

  return (
    <div className={`sl-scorebar sl-scorebar-${variant}`}>
      <div className="sl-scorebar-head">
        <span>{label}</span>
        <strong>{normalized == null ? 'N/D' : normalized.toFixed(2)}</strong>
      </div>
      <div className="sl-scorebar-track">
        <div className="sl-scorebar-fill" style={{ '--score-width': percentage }} />
      </div>
      {helper ? <small>{helper}</small> : null}
    </div>
  );
}
